import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';
import { first } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BreakpointService {

  constructor(public breakpointObserver: BreakpointObserver) { }

  isMobile(){
    if (this.breakpointObserver.isMatched('(max-width: 600px)')) {
      return true;
    }else{
      return false;
    }
  }
}
